/**
 * OCR text preview from screenshot import (server-side, not sent raw to the model).
 */
import React from 'react';

const OcrParsedPreview = ({ summary, stats, confidence, warnings, partial, source }) => {
  if (!summary) return null;

  return (
    <div className="mt-3 surface-panel p-3 light-surface">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <p className="text-label text-secondary font-medium">
          {source === 'vision' ? 'Read from screenshot (vision)' : 'Text read from screenshot (OCR)'}
        </p>
        {partial && (
          <span className="text-label px-2 py-0.5 rounded-md border border-warning text-warning bg-bone">
            Review required
          </span>
        )}
        {confidence != null && source !== 'vision' && (
          <span className="text-label text-faint figure">OCR confidence ~{Math.round(confidence)}%</span>
        )}
      </div>
      {warnings?.length > 0 && (
        <ul className="text-label text-warning mb-2 list-disc list-inside space-y-0.5">
          {warnings.map((w, i) => (
            <li key={i}>{w}</li>
          ))}
        </ul>
      )}
      {source !== 'vision' && (
        <pre className="text-label leading-relaxed text-secondary overflow-x-auto whitespace-pre font-mono max-h-36">
          {summary}
        </pre>
      )}
      {stats?.word_count != null && (
        <p className="text-label text-faint mt-1">{stats.word_count} words detected</p>
      )}
    </div>
  );
};

export default OcrParsedPreview;
